import { produce } from 'immer'
import type { ReferralTypes, State } from '../../typings'

export function setReferralTypeProducer(
  state: State,
  payload: ReferralTypes,
): State {
  return produce(state, (draft) => {
    draft.referralType = payload
  })
}
